import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import banner1 from '../assets/images/banner1.webp';
import banner2 from '../assets/images/banner2.webp';
import banner3 from '../assets/images/banner3.webp';
import banner4 from '../assets/images/banner4.webp';
import banner5 from '../assets/images/banner5.webp';


const slides = [
    {
        image: banner1,
        title: 'Your Video. Our Edit. Your Success',
        description: 'Turn your raw footage into scroll-stopping content for YouTube, TikTok, Instagram, and more – fast, creative, and affordable.'
    },
    {
        image: banner3,
        title: 'You shoot it – we shape it',
        description: 'Upload your video files, share your style and preferences, and we’ll craft a final cut that hits just right.'
    },
    {
        image: banner2,
        title: 'On-Time & Top-Quality Delivery',
        description: 'Experience unmatched efficiency with our commitment to timely and high-quality service, every single time.'
    },
    {
        image: banner4,
        title: 'Only pay for what you need',
        description: 'From short-form Reels to full-length vlogs – pick the editing package that fits your content. No subscriptions, no hidden fees.'
    },
    {
        image: banner5,
        title: 'Sit Back & Be Amazed',
        description: 'Get your fully edited video in as little as 24 hours. Revisions included. You are just a few clicks away from polished content.'
    }
];

const Banner = () => {
    const scrollToUpload = () => {
        const section = document.getElementById('upload-section');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <Carousel fade touch={true} interval={3000} pause="hover" className='banner'>
            {slides.map((slide, index) => (
                <Carousel.Item key={index}>
                    <div
                        className="banner-slide"
                        style={{ backgroundImage: `url(${slide.image})` }}
                    >

                        <Container>
                            <div className="overlay-content">
                                <h2>{slide.title}</h2>
                                <p>{slide.description}</p>
                                <button className="btn btn-primary mt-3" onClick={scrollToUpload}>Check it Now</button>
                            </div>
                        </Container>

                    </div>
                </Carousel.Item>
            ))}
        </Carousel>
    );
};

export default Banner;
